// extracted by mini-css-extract-plugin
export default {"cont":"Sidebar_cont__suG5Q","navbar":"Sidebar_navbar__983cQ","userdetails":"Sidebar_userdetails__lsO-A","logout":"Sidebar_logout__jngRi","chatnames":"Sidebar_chatnames__rcYN0"};